
class BestPriceWidget extends HTMLElement {
  constructor(){
    super();
    this.attachShadow({mode:'open'});
    this.open = false;
    this.loading = false;
    this.i18n = {
      'fr': { label: 'Meilleurs prix', heading:'Offres connues', shipping:'Livraison', total:'Total', view:"Voir l\'offre", updated:'Mis à jour', noData:'Aucune offre trouvée', close:'Fermer', best:'Meilleure offre', ours:'Notre prix', youSave:'Économie', disclaimer:'Les informations peuvent ne pas être exactes à 100 %. Vérifiez toujours le prix final sur le site du vendeur.' },
      'en': { label: 'Best price', heading:'Known offers', shipping:'Shipping', total:'Total', view:'View offer', updated:'Updated', noData:'No offers found', close:'Close', best:'Best deal', ours:'Our price', youSave:'You save', disclaimer:'Info may not be 100% accurate. Always verify the final price on the seller’s site.' },
      'de': { label: 'Bester Preis', heading:'Bekannte Angebote', shipping:'Versand', total:'Gesamt', view:'Angebot ansehen', updated:'Aktualisiert', noData:'Keine Angebote gefunden', close:'Schließen', best:'Bestes Angebot', ours:'Unser Preis', youSave:'Sie sparen', disclaimer:'Angaben sind ggf. nicht zu 100 % korrekt. Bitte Endpreis stets auf der Händlerseite prüfen.' }
    };
  }

  connectedCallback(){
    this.locale = (this.getAttribute('data-locale')||navigator.language||'en-US');
    const lang = this.locale.split('-')[0];
    this.dict = this.i18n[lang] || this.i18n['en'];
    this.currency = this.getAttribute('data-currency')||'EUR';
    this.sku = this.getAttribute('data-sku')||'';
    this.api = this.getAttribute('data-api')||'';
    this.inlineSource = this.getAttribute('data-source')||'';
    this.labelOverride = this.getAttribute('data-label');

    // Our own offer (optional but recommended)
    this.ourOffer = {
      seller: this.getAttribute('data-our-name') || this.dict.ours,
      price: this._num(this.getAttribute('data-our-price')),
      shipping: this._num(this.getAttribute('data-our-shipping')),
      url: this.getAttribute('data-our-url') || '#',
      currency: this.currency,
      lastSeen: new Date().toISOString(),
      _isOurs: true
    };

    // Optional custom disclaimer
    this.disclaimer = this.getAttribute('data-disclaimer') || this.dict.disclaimer;

    this.render();
    // Track if data has been fetched yet; only fetch when enabled
    this._dataLoaded = false;
    // Initialize visibility based on flag
    this.updateVisibility();
    // Close on Escape when panel is open
    this._bindGlobalClose = (e)=>{ if(this.open && e.key==='Escape') this.toggle(false); };
    document.addEventListener('keydown', this._bindGlobalClose);
    // React to global visibility toggles
    this._onVisibilityChange = (e)=>{ this.updateVisibility(); };
    document.addEventListener('best-price:visibility-changed', this._onVisibilityChange);

    // Mobile gesture disabled: visibility only via manual localStorage flag
    // this.attachMobileSecret();
  }

  disconnectedCallback(){
    document.removeEventListener('keydown', this._bindGlobalClose);
    document.removeEventListener('best-price:visibility-changed', this._onVisibilityChange);
    if(this._secretArea && this._onSecretTap){
      this._secretArea.removeEventListener('touchend', this._onSecretTap, { passive: true });
      this._secretArea.removeEventListener('pointerup', this._onSecretTap);
    }
  }

  template(css, html){ this.shadowRoot.innerHTML = `<style>${css}</style>${html}`; }

  render(){
    const label = this.labelOverride || this.dict.label;
    const css = `
      :host{position:relative;display:inline-block;font-family:inherit}
      .link{cursor:pointer;color:#16a34a;font-weight:600;text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:3px;transition:color .2s ease;font-size:1.1rem}
      .link:hover{color:#15803d}
      .backdrop{position:fixed;inset:0;background:rgba(17,24,39,.45);backdrop-filter:saturate(140%) blur(2px);opacity:0;pointer-events:none;transition:opacity .18s ease;z-index:9998}
      .backdrop.open{opacity:1;pointer-events:auto}
      .panel{position:absolute;top:calc(100% + .5rem);left:0;min-width:280px;max-width:min(92vw,560px);border-radius:16px;background:#fff;box-shadow:0 18px 50px rgba(0,0,0,.18);border:1px solid rgba(0,0,0,.06);opacity:0;transform:translateY(-6px) scale(.98);pointer-events:none;z-index:9999;overflow:hidden;display:flex;flex-direction:column}
      .panel.open{opacity:1;transform:translateY(0) scale(1);pointer-events:auto;animation:pop .20s ease}
      @keyframes pop{from{opacity:0;transform:translateY(-6px) scale(.98)}to{opacity:1;transform:translateY(0) scale(1)}}
      .bar{padding:.85rem 1rem;background:#16a34a;color:#fff;position:relative}
      .bar .title{font-weight:700;font-size:1.2rem}
      .bar .close{position:absolute;right:.5rem;top:.5rem;background:none;border:none;color:#fff;font-size:1.2rem;cursor:pointer}
      .list{padding:.6rem;flex:1;overflow:auto}
      .row{display:flex;flex-wrap:wrap;align-items:flex-start;padding:.5rem;border-bottom:1px solid #e5e7eb;gap:.5rem}
      .row.ours{background:#f0fdf4}
      .rank{width:24px;height:24px;border-radius:999px;background:#e5f8ec;color:#0a7a2b;display:grid;place-items:center;font-weight:700;font-size:1rem}
      .seller{font-weight:600;font-size:1.1rem}
      .meta{font-size:1rem;color:#6b7280}
      .chip{font-size:.9rem;padding:.12rem .3rem;border-radius:999px;background:#111;color:#fff}
      .chip.ours{background:#065f46}
      .chip.best{background:#16a34a}
      .actions{display:flex;align-items:center;gap:.5rem}
      .actions a{display:inline-block;padding:.45rem .7rem;border-radius:8px;background:#16a34a;color:white;text-decoration:none;font-weight:600;font-size:1rem}
      .foot{padding:.6rem .9rem;color:#6b7280;font-size:1rem;display:flex;justify-content:space-between;align-items:flex-start;gap:.5rem}
      .foot .disclaimer{line-height:1.3;opacity:.9;font-size:1rem}
      @media(max-width:640px){
        .panel{position:fixed;left:0;right:0;bottom:0;top:auto;width:100%;max-height:min(94svh,94vh);border-radius:16px 16px 0 0;padding-bottom:calc(env(safe-area-inset-bottom,0px) + .5rem)}
        .bar{position:sticky;top:0}
        .list{-webkit-overflow-scrolling:touch;overscroll-behavior:contain}
        .row{align-items:center}
        .actions{flex-wrap:wrap}
        .actions a{font-size:1.05rem;padding:.55rem .85rem}
        .foot{position:sticky;bottom:0;background:#fff;padding-bottom:calc(env(safe-area-inset-bottom,0px) + .5rem)}
      }
      /* Ensure full width in portrait on mobile */
      @media(max-width:640px) and (orientation: portrait){
        .panel{max-width:100vw}
      }
    `;
    // Only show the widget if dev mode is enabled
    const html = `
      <span class="link" role="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="bp-panel" style="display: none;">${label}</span>
      <div class="backdrop" id="bp-backdrop"></div>
      <section class="panel" id="bp-panel" role="dialog" aria-modal="true" aria-label="${this.dict.heading}">
        <div class="bar">
          <div class="title">${this.dict.heading}</div>
          <button class="close" type="button" aria-label="${this.dict.close}">✕</button>
        </div>
        <div class="list" id="bp-list" tabindex="-1"></div>
        <div class="foot"><div class="disclaimer">${this.disclaimer}</div><div class="count" id="bp-count"></div></div>
      </section>
    `;
    this.template(css, html);
    // Show the widget only when dev mode is enabled
    this.shadowRoot.querySelector('.link').addEventListener('click', ()=>this.toggle());
    this.shadowRoot.getElementById('bp-backdrop').addEventListener('click', ()=>this.toggle(false));
    this.shadowRoot.querySelector('.bar .close').addEventListener('click', ()=>this.toggle(false));
  }

  updateVisibility(){
    const linkElement = this.shadowRoot?.querySelector?.('.link');
    if(!linkElement) return;
    const enabled = localStorage.getItem('SHOW_BEST_PRICE_WIDGET') === 'true';
    if(enabled){
      linkElement.style.display = 'inline';
      if(!this._dataLoaded){
        // Lazy-load data upon first enable
        this.loadData();
      }
    } else {
      linkElement.style.display = 'none';
      if(this.open) this.toggle(false);
    }
  }

  attachMobileSecret(){
    try{
      const isCoarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
      if(!isCoarse) return; // mobile/tablet only
      // Try to attach to a nearby price container; fallback to the element's parent
      const area = this.closest('[id^="price-"]') || this.parentElement || document.body;
      if(!area) return;
      this._secretArea = area;
      let tapCount = 0;
      let last = 0;
      const windowMs = 800; // time window for the sequence
      this._onSecretTap = ()=>{
        const now = Date.now();
        tapCount = (now - last) < 350 ? (tapCount + 1) : 1;
        last = now;
        if(tapCount >= 3){
          tapCount = 0;
          const current = localStorage.getItem('SHOW_BEST_PRICE_WIDGET') === 'true';
          const next = !current;
          localStorage.setItem('SHOW_BEST_PRICE_WIDGET', String(next));
          document.dispatchEvent(new CustomEvent('best-price:visibility-changed', { detail: { enabled: next, source: 'mobile-secret' } }));
        }
        // Reset if no further taps
        clearTimeout(this._tapResetTimer);
        this._tapResetTimer = setTimeout(()=>{ tapCount = 0; }, windowMs);
      };
      // Use both pointer and touch to be robust across browsers
      area.addEventListener('touchend', this._onSecretTap, { passive: true });
      area.addEventListener('pointerup', this._onSecretTap);
    }catch(e){ /* noop */ }
  }

  toggle(force){
    this.open = (typeof force==='boolean')? force : !this.open;
    const panel = this.shadowRoot.getElementById('bp-panel');
    const backdrop = this.shadowRoot.getElementById('bp-backdrop');
    panel.classList.toggle('open', this.open);
    backdrop.classList.toggle('open', this.open);
  }

  async loadData(){
    let offers = [];
    
    // First check for inline source data
    if(this.inlineSource){ 
      try{ 
        const el=document.getElementById(this.inlineSource); 
        if(el) offers=JSON.parse(el.textContent.trim()); 
      }catch(e){}
    }
    
    // Then try the external API if no inline data
    if(!offers.length && this.api){
      const url=this.api.replace('{sku}',encodeURIComponent(this.sku||''));
      try{ 
        const res=await fetch(url,{headers:{'Accept':'application/json'}}); 
        if(res.ok) {
          const data = await res.json();
          // Transform the API response to match our expected format
          if(data && data.length > 0) {
            const product = data[0];
            if(product.variants && product.variants.length > 0) {
              const variant = product.variants[0];
              if(variant.competitors && variant.competitors.length > 0) {
                offers = variant.competitors.map(c => ({
                  seller: c.competitor?.name || 'Unknown',
                  price: c.currentPrice,
                  shipping: 0, // Assuming free shipping for now
                  url: c.productUrl || '#',
                  currency: this.currency
                }));
              }
            }
          }
        }
      }catch(e){
        console.error('Error fetching from API:', e);
      }
    }
    
    // Determine if we have a valid in-house offer
    const oursValid = Number.isFinite(this.ourOffer.price);

    // Fallback to default offers only when we have no competitor data
    // AND no valid in-house price to show. If we do have our own price,
    // do not fabricate competitors.
    if(!offers.length && !oursValid){
      offers=[
        {seller:'Competitor A',price:199.9,shipping:4.9,url:'#'},
        {seller:'Competitor B',price:209.0,shipping:0,url:'#'}
      ];
    }

    if(oursValid) offers.push({...this.ourOffer});
    
    const items=offers.map(o=>({
      seller:o.seller||'—',
      price:this._num(o.price),
      shipping:this._num(o.shipping),
      url:o.url||'#',
      currency:o.currency||this.currency,
      total:this._num(o.price)+this._num(o.shipping),
      _isOurs:!!o._isOurs
    })).sort((a,b)=>a.total-b.total);
    
    this.renderList(items);
    this._dataLoaded = true;
  }

  renderList(items){
    const list=this.shadowRoot.getElementById('bp-list');
    const count=this.shadowRoot.getElementById('bp-count');
    if(!items.length){ list.innerHTML=`<div class="meta">${this.dict.noData}</div>`; count.textContent=''; return; }
    const our=items.find(i=>i._isOurs);
    list.innerHTML=items.map((i,idx)=>{
      const isOurs=i._isOurs;
      const shippingDisplay = Number.isFinite(i.shipping) && i.shipping > 0 ? ' · '+this.dict.shipping+': '+this.fmt(i.shipping,i.currency) : '';
      const meta=`${this.dict.total}: ${this.fmt(i.total,i.currency)}${shippingDisplay}`;
      let badge='';
      if(isOurs&&idx===0) badge=`<span class="chip ours">${this.dict.best}</span>`;
      if(our && !isOurs){const diff=i.total-our.total;if(diff>0) badge=`<span class="chip">${this.dict.youSave}: ${this.fmt(diff,i.currency)}</span>`;}
      return `<div class="row${isOurs?' ours':''}"><div class="rank">${idx+1}</div><div class="content"><div class="seller">${i.seller}</div><div class="meta">${meta}</div></div><div class="actions">${badge}<a href="${i.url}" target="_blank">${this.dict.view}</a></div></div>`;
    }).join('');
    count.textContent=`${items.length} ${items.length>1?'offers':'offer'}`;
  }

  fmt(n,c){ try{return new Intl.NumberFormat(this.locale,{style:'currency',currency:c||this.currency}).format(n);}catch(e){return (c||this.currency)+" "+Number(n).toFixed(2);} }
  _num(v){const n=Number(v);return Number.isFinite(n)?n:0;}
}

if (!customElements.get('best-price-widget')) {
  customElements.define('best-price-widget', BestPriceWidget);
}

// // Global keyboard shortcut to toggle visibility flag without dev console
// // Combination: Ctrl + Alt + Shift + B (uncommon and cross‑platform)
// (function(){
//   let lastToggleAt = 0;
//   document.addEventListener('keydown', function(e){
//     // Ignore if typing in inputs or using CMD/Meta
//     const target = e.target;
//     const isTyping = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable);
//     if(isTyping || e.metaKey) return;
//     if(e.ctrlKey && e.altKey && e.shiftKey && (e.key && e.key.toLowerCase() === 'b')){
//       // Basic debounce to avoid repeats when key is held down
//       const now = Date.now();
//       if(now - lastToggleAt < 400) return;
//       lastToggleAt = now;
//       const current = localStorage.getItem('SHOW_BEST_PRICE_WIDGET') === 'true';
//       const next = !current;
//       localStorage.setItem('SHOW_BEST_PRICE_WIDGET', String(next));
//       // Notify all widgets on this page
//       document.dispatchEvent(new CustomEvent('best-price:visibility-changed', { detail: { enabled: next } }));
//       // Optional: prevent default if any default mapping exists
//       e.preventDefault();
//     }
//   });
// })();
